import ErrorIcon from '@mui/icons-material/Error';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import * as React from 'react';
import { getErrorMessage } from '../utils';
export function showAlertDialog(params) {
    var _a;
    newDialog({
        id: generateNewDialogId(),
        type: 'dialog',
        fullScreen: undefined,
        fullWidth: params.fullWidth,
        maxWidth: params.maxWidth,
        title: params.title,
        content: params.content,
        responseOnSuccess: undefined,
        responseOnError: undefined,
        buttons: [
            {
                label: (_a = params.closeLabel) !== null && _a !== void 0 ? _a : 'OK',
                color: 'primary',
                onClick: params.onClose,
                clickOnEscapeKeyDown: true,
            },
        ],
        custom: undefined,
        onEscapeKeyDown: undefined,
    });
}
export function showConfirmDialog(params) {
    var _a, _b;
    newDialog({
        id: generateNewDialogId(),
        type: 'dialog',
        fullScreen: undefined,
        fullWidth: params.fullWidth,
        maxWidth: params.maxWidth,
        title: params.title,
        content: params.content,
        responseOnSuccess: undefined,
        responseOnError: undefined,
        buttons: [
            {
                label: (_a = params.cancelLabel) !== null && _a !== void 0 ? _a : 'Cancel',
                color: 'primary',
                onClick: params.onCancel,
                clickOnEscapeKeyDown: true,
            },
            {
                label: (_b = params.confirmLabel) !== null && _b !== void 0 ? _b : 'OK',
                color: 'primary',
                onClick: params.onConfirm,
            },
        ],
        custom: undefined,
        onEscapeKeyDown: undefined,
    });
}
export function showSaveDialog(params) {
    var _a, _b, _c;
    const buttons = [];
    if (params.onCancel) {
        buttons.push({
            label: (_a = params.cancelLabel) !== null && _a !== void 0 ? _a : 'Cancel',
            color: 'primary',
            onClick: params.onCancel,
            clickOnEscapeKeyDown: true,
        });
    }
    buttons.push({
        label: (_b = params.dontSaveLabel) !== null && _b !== void 0 ? _b : 'Do Not Save',
        color: 'primary',
        onClick: params.onDontSave,
    });
    buttons.push({
        label: (_c = params.saveLabel) !== null && _c !== void 0 ? _c : 'Save',
        color: 'primary',
        onClick: params.onSave,
    });
    newDialog({
        id: generateNewDialogId(),
        type: 'dialog',
        fullScreen: undefined,
        fullWidth: params.fullWidth,
        maxWidth: params.maxWidth,
        title: params.title,
        content: params.content,
        responseOnSuccess: undefined,
        responseOnError: undefined,
        buttons: buttons,
        custom: undefined,
        onEscapeKeyDown: undefined,
    });
}
export function showErrorDialog(params) {
    newDialog({
        id: generateNewDialogId(),
        type: 'error',
        fullScreen: undefined,
        fullWidth: params.fullWidth,
        maxWidth: params.maxWidth,
        title: params.title,
        content: undefined,
        responseOnSuccess: undefined,
        responseOnError: undefined,
        buttons: [
            {
                label: params.closeLabel || 'OK',
                color: 'primary',
                onClick: params.onClose,
                clickOnEscapeKeyDown: true,
            },
        ],
        custom: undefined,
        onEscapeKeyDown: undefined,
    });
}
export function handleErrorDialog(error) {
    console.error(error);
    showErrorDialog({ title: getErrorMessage(error) });
}
export function showProgressDialog(params) {
    const id = generateNewDialogId();
    newDialog({
        id: id,
        type: 'progress',
        fullScreen: undefined,
        fullWidth: params.fullWidth,
        maxWidth: params.maxWidth,
        title: params.title,
        content: undefined,
        responseOnSuccess: undefined,
        responseOnError: undefined,
        buttons: [],
        custom: undefined,
        onEscapeKeyDown: undefined,
    }, () => params.callback(() => {
        if (instance) {
            instance.setState((prevState) => ({ dialogs: prevState.dialogs.filter((d) => d.id !== id) }));
        }
    }));
}
export function showCustomDialog(params) {
    newDialog({
        id: generateNewDialogId(),
        type: undefined,
        fullScreen: params.fullScreen,
        fullWidth: params.fullWidth,
        maxWidth: params.maxWidth,
        title: undefined,
        content: undefined,
        responseOnSuccess: undefined,
        responseOnError: undefined,
        buttons: [],
        custom: params.content,
        onEscapeKeyDown: params.onEscapeKeyDown,
    });
}
let instance;
export class DialogHelper extends React.Component {
    constructor(props) {
        super(props);
        this.close = (dialog, closed) => {
            this.setState((prevState) => ({ dialogs: prevState.dialogs.filter((d) => d.id !== dialog.id) }), () => {
                if (closed) {
                    closed();
                }
            });
        };
        this.state = { dialogs: [] };
    }
    componentDidMount() {
        if (!instance) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            instance = this;
            if (!this.props.doNotCloseDialogsOnPopState) {
                this.popStateListener = () => {
                    this.setState({ dialogs: [] });
                };
                window.addEventListener('popstate', this.popStateListener);
            }
        }
        else {
            console.error('DialogHelper should be used only once');
        }
    }
    componentWillUnmount() {
        if (instance === this) {
            if (this.popStateListener) {
                window.removeEventListener('popstate', this.popStateListener);
                this.popStateListener = undefined;
            }
            instance = undefined;
        }
    }
    render() {
        return this.state.dialogs.map((dialog) => {
            var _a;
            const dialogAriaLabelledBy = `dialog-title-${dialog.id}`;
            const dialogAriaDescribedBy = `dialog-content-${dialog.id}`;
            return (React.createElement(Dialog, { key: dialog.id, open: true, fullScreen: dialog.fullScreen, fullWidth: dialog.fullWidth, maxWidth: (_a = dialog.maxWidth) !== null && _a !== void 0 ? _a : 'sm', onClose: (event, reason) => {
                    if (reason === 'escapeKeyDown') {
                        if (dialog.onEscapeKeyDown) {
                            dialog.onEscapeKeyDown((closed) => this.close(dialog, closed));
                        }
                        else {
                            for (const button of dialog.buttons) {
                                if (button.clickOnEscapeKeyDown) {
                                    this.close(dialog, button.onClick);
                                    break;
                                }
                            }
                        }
                    }
                }, sx: {
                    '& .MuiDialog-container.MuiDialog-scrollPaper .MuiPaper-root': {
                        flex: '1 1 auto',
                    },
                }, "aria-labelledby": dialogAriaLabelledBy, "aria-describedby": dialogAriaDescribedBy },
                !dialog.custom && this.renderDialogContent(dialog, dialogAriaLabelledBy, dialogAriaDescribedBy),
                dialog.custom && dialog.custom((closed) => this.close(dialog, closed), dialogAriaLabelledBy, dialogAriaDescribedBy)));
        });
    }
    renderDialogContent(dialog, dialogAriaLabelledBy, dialogAriaDescribedBy) {
        if (dialog.type === 'error') {
            return (React.createElement(React.Fragment, null,
                React.createElement(DialogContent, null,
                    React.createElement("div", { style: { display: 'flex', alignItems: 'center', paddingTop: 16 } },
                        React.createElement(ErrorIcon, { color: 'error' }),
                        React.createElement("div", { style: { paddingLeft: 8 } },
                            React.createElement(Typography, { id: dialogAriaLabelledBy, variant: 'body1', color: 'error' }, dialog.title)))),
                this.renderActions(dialog)));
        }
        else if (dialog.type === 'progress') {
            return (React.createElement(React.Fragment, null,
                React.createElement(DialogContent, { style: { padding: 16 } },
                    React.createElement("div", { style: { display: 'flex', alignItems: 'center', padding: 16 } },
                        React.createElement(CircularProgress, { size: 24, "aria-hidden": true }),
                        React.createElement("div", { style: { paddingLeft: 8 } },
                            React.createElement(Typography, { id: dialogAriaLabelledBy, variant: 'body1' }, dialog.title))))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                dialog.title && React.createElement(DialogTitle, { id: dialogAriaLabelledBy }, dialog.title),
                dialog.content && React.createElement(DialogContent, { id: dialogAriaDescribedBy }, dialog.content),
                this.renderActions(dialog)));
        }
    }
    renderActions(dialog) {
        return (React.createElement(DialogActions, null, dialog.buttons.map((button, i) => (React.createElement(Button, { key: i, color: button.color, onClick: () => this.close(dialog, button.onClick), "data-test": `${i}-dialog-button` }, button.label)))));
    }
}
function newDialog(dialog, callback) {
    if (instance) {
        instance.setState((prevState) => ({
            dialogs: [...prevState.dialogs, dialog],
        }), callback);
    }
}
let dialogCounter = 0;
function generateNewDialogId() {
    return '' + ++dialogCounter;
}
